// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItem-cls1_ogm","cls2":"CreateSocialItem-cls2_AD0 CreateSocialItem-cls1_ogm"};